/* eslint-disable react-hooks/set-state-in-effect */
/* eslint-disable react-hooks/preserve-manual-memoization */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable react/forbid-component-props */
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { Headline, Text } from '@oneaudi/unified-web-alpha-components';
import { useSelector } from 'react-redux';
import useAnimations from '../../../hooks/useAnimations';
import FallbackCarDefault from '../../../assets/fallback_car_default.png';
import { device } from '../../../styles/devices';
import type { StockCarTypes, VehicleByAudiCode } from '../../../types';
import { SkeletonImage, SkeletonVehicle } from '../../Skeleton';
import ExposedHeader from '../ExposedHeader';
import {
  MobileWrapper,
  VehicleInfoContainer,
  ImageWrapper,
  VehicleImage,
  VehicleName,
  Trimline,
  Title,
} from '../VehicleInfo.styles';
import { selectAppConfig } from '../../../redux/appConfigReducer';
import { IS_T1_PAGE } from '../../../constants/environment';
import useSourceOfLead from '../../../hooks/useSourceOfLead';
import setTransparentImage from '../../../functions/setTransparentImage';

interface VinSpecificVehicleProps {
  vehicle?: StockCarTypes | VehicleByAudiCode;
  isVehicleLoading: boolean;
}

const VinSpecificVehicle: React.FC<VinSpecificVehicleProps> = ({ isVehicleLoading, vehicle }) => {
  const { t } = useTranslation();
  const isTablet = useMediaQuery({ query: device.tablet });
  const [isOpen, setIsOpen] = useState(false);

  const { offers } = useSelector(selectAppConfig);
  const { specificSource } = useSourceOfLead();

  const isOfferPage = specificSource === 'offers';
  const isFYMPage = specificSource === 'fym';

  const dropdownHeigh = 382;
  const { dropdownAnimation, filtersAccordianAnimation } = useAnimations(isOpen, dropdownHeigh);

  const image = useMemo(() => {
    const dealerImage = vehicle?.images.find((toCheck) => toCheck.type !== 'render')?.url;
    const renderImage = vehicle?.images.find((toCheck) => toCheck.type === 'render')?.url;
    const firstImage = vehicle?.images?.[0]?.url;

    if (isOfferPage && offers?.image) return offers.image;
    if (IS_T1_PAGE && renderImage) return setTransparentImage(renderImage);
    if (!IS_T1_PAGE && dealerImage) return dealerImage;
    return setTransparentImage(firstImage) || FallbackCarDefault;
  }, [isOfferPage, offers?.image, vehicle?.images]);

  const modelName = vehicle?.titleText;
  const trimName = vehicle?.subtitleText;

  const vehicleLabel = useMemo(() => {
    if (isFYMPage) return t('digitalLeads.vehicle.matchedVehicle');
    if (isOfferPage) return t('digitalLeads.vehicle.offerOfInterest');
    return t('digitalLeads.vehicle.vehicleOfInterest');
  }, [isFYMPage, isOfferPage, t]);

  useEffect(() => {
    if (isTablet) setIsOpen(false);
  }, [isTablet]);

  const renderVehicleInfo = useMemo(() => {
    if (process.env.IS_LEGACY) {
      return (
        <>
          <VehicleName data-testid="vehicle-info-name">{modelName}</VehicleName>
          <Trimline>{trimName}</Trimline>
        </>
      );
    }

    return (
      <>
        <Headline
          data-testid="vehicle-info-name"
          margin={['8px', 0, 0, 0]}
          variant={{ type: 'headline', order: '3', weight: 'normal' }}
          tag="h2"
        >
          {modelName}
        </Headline>
        <Text margin={['12px', 0, 0, 0]} variant={{ order: '1', style: 'normal' }} tag="p">
          {trimName}
        </Text>
      </>
    );
  }, [modelName, trimName]);

  return (
    <>
      {dropdownAnimation(
        (props, item) =>
          item && (
            <MobileWrapper style={props}>
              <VehicleInfoContainer style={filtersAccordianAnimation} data-testid="vehicle-info">
                <ImageWrapper data-testid="vehicle-info-image">
                  {isVehicleLoading ? (
                    <SkeletonImage data-testid="skeleton-image" />
                  ) : (
                    <VehicleImage src={image} />
                  )}
                </ImageWrapper>
                {isVehicleLoading ? (
                  <SkeletonVehicle data-testid="skeleton-vehicle" />
                ) : (
                  renderVehicleInfo
                )}
              </VehicleInfoContainer>
            </MobileWrapper>
          ),
      )}
      {!isTablet && (
        <ExposedHeader
          isOpened={isOpen}
          setIsOpened={setIsOpen}
          modelName={modelName}
          vehicleLabel={vehicleLabel}
        />
      )}
      {isTablet && (
        <VehicleInfoContainer data-testid="vehicle-info-tablet">
          {isVehicleLoading ? (
            <SkeletonImage data-testid="skeleton-image" />
          ) : (
            <ImageWrapper data-testid="vehicle-info-image">
              <VehicleImage src={image} />
            </ImageWrapper>
          )}
          {process.env.IS_LEGACY ? (
            <Title paddingTop>{vehicleLabel}</Title>
          ) : (
            <Headline
              margin={['24px', 0, 0, 0]}
              variant={{ type: 'headline', order: '4', weight: 'normal' }}
              tag="h2"
            >
              {vehicleLabel}
            </Headline>
          )}

          {isVehicleLoading ? (
            <SkeletonVehicle data-testid="skeleton-vehicle" />
          ) : (
            renderVehicleInfo
          )}
        </VehicleInfoContainer>
      )}
    </>
  );
};

export default VinSpecificVehicle;
